import { PostHogProvider } from "posthog-js/react";
import "@/index.scss";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { BackgroundSoundPlayer } from "./helpers/SoundPlayer";
import { router } from "./router";
import "./sentry";
import { LocationProvider } from "./context/LocationProvider";
import LogRocket from "logrocket";
import { isMyAppWKWebView } from "./bridge/isMyAppWKWebView";
import { onLoaded } from "./bridge/onLoaded";
// import { TransitionProvider } from "./context/TransitionProvider";



if (!window.Android && !isMyAppWKWebView()) {
  LogRocket.init('inyto8/skillscratch');
}

window.onAppear = () => {
  BackgroundSoundPlayer.resume();
};

window.onDisappear = () => {
  BackgroundSoundPlayer.pause();
};

onLoaded();

// getLocationFrom();

// biome-ignore lint/style/noNonNullAssertion: <explanation>
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <LocationProvider>
      <PostHogProvider
        apiKey="phc_TlaJgN7xD3ab1WAakbnY2cWE3zQ8URuJma6qhBmDAGy"
        options={{
          api_host: "https://us.i.posthog.com",
          disable_session_recording: true,
        }}
      >
        <RouterProvider router={router} />
      </PostHogProvider>
    </LocationProvider>
  </StrictMode>
);
